module.exports = __webpack_public_path__ + "img/p08.d13c0294.png";